import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { ViewSettingsRepositoryBase } from '@skylab-shared/business';
export { ViewSettingsRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(ViewSettingsRepositoryBase)
export class ViewSettingsRepository {
    public constructor(
        http: Http
    ) { }
}
